import { Injectable } from '@angular/core';
import {User} from './user';
import { ApiService } from '../api-service/api-service';
import { Events } from 'ionic-angular';


declare var AWS: any;

@Injectable()
export class UserData {
    //this is NOT the same as user sub, it is identity sub for IAM
     
    private userSub: string = null;
    public voteTimerReset:string = new Date().toISOString();
    public votes:number = 0;
    public votesMax:number = 45;
    public badges:any = [];
    public voteGeneratorPayout:number = 5;
    public points:number = 0;
    public voteGenerator:number = 0;
    public voteGeneratorMax:number = 10;
    public level:number = 1;
    public wins:number = 0;
    public userName:string;
    public avatarKey:string;

    
    constructor(user:User, private server:ApiService, private events: Events)
    {
        //this.userSub = this.userSub = AWS.config.credentials.identityId;
        //server.getUserData(this.userSub,this.getUserDataCallBack);
        server.getUserData(this.getUserDataCallBack);

    }

    public refreshUserData(){
      this.server.getUserData(this.getUserDataCallBack);
    }

          //Fat arrow used to keep scope, private entry back in
  public getUserDataCallBack = (userData) => {
    this.setUserData(userData);
  }
  setUserData(userData){
    //TODO hydrate user data from db
    this.votes = userData.votes;
    this.voteTimerReset = userData.voteTimerReset;
    this.badges = userData.badges;
    this.voteGeneratorPayout = userData.voteGeneratorPayout;
    this.points = userData.points;
    this.voteGenerator = userData.voteGenerator;
    this.voteGeneratorMax = userData.voteGeneratorMax;
    this.votesMax = userData.votesMax;
    this.level = userData.level;
    
    if(userData.userName){
      this.userName = userData.userName;
    }

    if(userData.avatarKey){
      this.avatarKey = userData.avatarKey;
    }
    

    this.events.publish('user-refreshed', userData);
  }

}



// WEBPACK FOOTER //
// ./src/providers/user-data.ts